export default "__VITE_ASSET__DznE$Pz0__"